import type { AlertItem } from '@/types/Alert'

export const createConfigurationErrorFormatter = () => {
  // Translation mapping for section labels (must match tab translation keys)
  const labelMap: Record<string, string> = {
    general_information: 'general_information',
    conversational_flow: 'conversational_flow',
    inactivity: 'call_limits',
    customer_intents: 'intent_recognition',
    intents_detection: 'intent_recognition',
    knowledge: 'knowledge',
    call_duration_limits: 'call_limits',
    experimental: 'experimental',
    form_schema: 'experimental',
    speech: 'general_information',
  }

  // Tab order for sorting errors
  const tabOrder = [
    'general_information',
    'conversational_flow',
    'intent_recognition',
    'knowledge',
    'call_limits',
    'experimental',
  ]

  return (messages: string[]): AlertItem[] => {
    // Group unique invalid fields by mapped label (tab name). A single field may
    // fail several class-validator constraints, but should count only once.
    const errorPathsByLabel: Record<string, Set<string>> = {}

    messages.forEach((msg: string) => {
      // Skip scenarios errors as they are derived from other fields
      if (msg.startsWith('scenarios.')) {
        return
      }

      const match = /^settings\.([^\s.]+)(?:\.|\s|$)/.exec(msg)
      const section = match ? match[1] : 'intents_detection'
      const label = labelMap[section] ?? section.replace(/_/g, ' ')
      const propertyPath = /^\S+/.exec(msg)?.[0] ?? msg

      errorPathsByLabel[label] ??= new Set()
      errorPathsByLabel[label].add(propertyPath)
    })

    // Format message with section counts, sorted by tab order
    return Object.entries(errorPathsByLabel)
      .sort(([a], [b]) => {
        const indexA = tabOrder.indexOf(a)
        const indexB = tabOrder.indexOf(b)
        // Put unknown labels at the end
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB)
      })
      .map(([label, paths]) => ({
        label,
        count: paths.size,
      }))
  }
}
